import React, { useEffect, useState } from "react"
import { Paper, Grid, Box } from "@material-ui/core"
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputReactDatepicker,
  InputCheckboxMaster,
  ModalDeleteConfirm,
  InputTextArea,
} from "App/Component/ui"

import {
  RESET_STATE_KUNJUNGAN_IGD,
  STYLE_MASTER_GUDANG_UTAMA,
  FormAsuransi,
  FormDataPasien,
  validation,
  ModalTriage,
  getByNoSEPandID,
} from "."
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants"

import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
  toUTCFormat,
  defaultDateDisplay,
  defaultDateInputDisplay,
  today,
  optionCaraMasuk,
} from "App/utils/helpers"
import { Person } from "@material-ui/icons"
import { SearchIcon } from "App/Assets"
import {
  ModalCancel,
  ModalSEP,
  ModalTutupKunjungan,
} from "../../KunjunganRawatJalan/ui"
import {
  createPenjualan,
  sebabSakitSelect,
  useModalBukaKunjungan,
  validasiNoBpjs,
} from "../../utils"
import { FormSEP } from "../../KunjunganRawatJalan/ui/FormKunjunganRawatJalan"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { useDispatchWrapper } from "hooks"
import ModalForceAsuransi from "../../KunjunganRawatJalan/ui/Modal/ModalForceAsuransi"
import { useSelector } from "react-redux"
import ButtonActionIgd from "./ButtonActionIgd"
import { escapeWhiteSpace, messageError } from "utils/all"
import { useModalCetakManualSEP } from "../../KunjunganRawatJalan/ui/Modal/ModalCetakManualSEP"

export default function FormKunjunganRawatJalan({
  formData,
  setFormData,
  handleClickButtonKunjunganBaru,
  setNewData,
  registrationId,
  setRegistrationId,
}) {
  const classes = STYLE_MASTER_GUDANG_UTAMA()
  const { state } = useDispatchWrapper()
  const ASURANSI_BPJS_ID = state.wrapper_insurance_bpjs_id

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const [rowsTriage, setRowsTriage] = useState([])
  const [showModalCancel, setShowModalCancel] = useState(false)
  const [showModalTutup, setShowModalTutup] = useState(false)
  const { ButtonBukaKunjungan, ModalConfirmBukaKunjungan } =
    useModalBukaKunjungan(registrationId, setNewData)
  const [showModalTriage, setShowModalTriage] = useState(false)
  const [showModalSEP, setShowModalSEP] = useState(false)
  const [showModalDuplikasiSEP, setShowModalDuplikasiSEP] = useState({
    state: false,
    message: "",
  })
  const [detailSEP, setDetailSEP] = useState(null)

  const stateRedux = useSelector((state) => state)
  const master = stateRedux.master
  const setting = stateRedux.setting
  const JENIS_LAYANAN_IGD_ID = setting.id_jenis_layanan_igd
  const KELAS_NON_KELAS = setting.id_non_kelas

  const checkAsuransiBpjs = () => {
    return parseInt(formData.insurance_id) === parseInt(ASURANSI_BPJS_ID)
  }

  const [showModalForce, setShowModalForce] = useState(false)
  const [rowsForce, setRowsForce] = useState([])

  const submit = async ({ hakKelas, provUmum, force = false }) => {
    const defaultData = {
      date: toUTCFormat(formData.date),
      kelaskunjungan_id: formData.kelaskunjungan_id,
      patients_id: formData.patients_id,
      force_cek_insurance: force,

      nohp: formData.nohp,
      nik: formData.nik,
      company_id: formData.company_id,
      insurance_id: formData.insurance_id,

      insurance_no: formData.insurance_no,
      norujukan: formData.norujukan,
      nokontrol: formData.nokontrol,
      nosep: formData.no_sep,

      sebab_sakit: formData.sebab_sakit,

      umur: formData.umur,
      doctor_id: formData.doctor_id,

      id_triage: formData.id_triage,

      isexternalrm: parseInt(formData.jenisrm) === 1 ? 1 : 0,

      hak_kelas: checkAsuransiBpjs() ? hakKelas.kode : "",
      nama_hak_kelas: checkAsuransiBpjs() ? hakKelas.keterangan : "",

      kode_ppk_perujuk: checkAsuransiBpjs() ? provUmum.kdProvider : "",
      nama_ppk_perujuk: checkAsuransiBpjs() ? provUmum.nmProvider : "",
      remark: formData.remark,
      cara_masuk: formData.cara_masuk,
    }
    if (isNull(registrationId)) {
      return instance2.post(LIST_URL_REGISTRASI.kunjungan_igd.add, defaultData)
    } else {
      return instance2.post(
        LIST_URL_REGISTRASI.kunjungan_igd.update,
        defaultData,
        {
          headers: {
            idregistration: registrationId,
          },
        },
      )
    }
  }

  const handleSubmit = async (e, force) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      const valid = validation(formData)
      if (valid.state) {
        const validasiBpjs =
          parseInt(formData.insurance_id) === ASURANSI_BPJS_ID &&
          formData.validasi_bpjs
            ? await validasiNoBpjs(formData.insurance_no)
            : {
                state: true,
                message: "",
                data: {
                  hakKelas: "",
                  provUmum: "",
                },
              }
        if (validasiBpjs.state) {
          const res = await submit({
            hakKelas: validasiBpjs.data.hakKelas,
            provUmum: validasiBpjs.data.provUmum,
            force,
          })

          if (res.data.status === 200) {
            if (isNull(registrationId)) {
              defaultToastSuccess("Berhasil menambah Kunjungan IGD")
              setRegistrationId(res.data.registration_id)
              setFormData({
                ...formData,
                id: res.data.registration_id,
                gender_print: formData.gender_print,
                insurance_type_name: res.data.insurance_type_name,
                isexternalrm: false,
              })

              // if (parseInt(formData.insurance_id) === ASURANSI_BPJS_ID) {
              //   await createPenjualan({
              //     dokterID: formData.doctor_id,
              //     asuransiNo: formData.insurance_no,
              //     kunjunganID: res.data.registration_id,
              //     rmID: formData.patients_id,
              //     rmName: formData.nama_rm,
              //     type: "RIGD",
              //     asuransiBpjsId: ASURANSI_BPJS_ID,
              //     jenisLayananID: JENIS_LAYANAN_IGD_ID,
              //     kelasID: KELAS_NON_KELAS,
              //   })

              //   // if (!responsePenjualan.state) {
              //   //   defaultToastError(responsePenjualan.message);
              //   // }
              // }
            } else {
              defaultToastSuccess("Berhasil mengubah Kunjungan IGD")
            }
            await setNewData()
          } else {
            if (res.data.status === 206) {
              setShowModalDuplikasiSEP({
                state: true,
                message: res.data.message,
              })
            } else {
              setShowModalForce(true)
              setRowsForce(res.data.body)
            }
          }
        } else {
          defaultToastError(validasiBpjs.message)
        }
      } else {
        defaultToastError(valid.message)
      }
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]:
        text === "no_sep" ? escapeWhiteSpace(e.target.value) : e.target.value,
    })
  }

  const handleChangeAsuransi = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.value.split,
    })
  }

  const handleClickButtonSEP = async () => {
    const detail = await getByNoSEPandID(registrationId, formData.no_sep)
    if (detail.state) {
      setDetailSEP(detail.data)
    }
    setShowModalSEP(!showModalSEP)
  }

  useEffect(() => {
    setFormData({
      ...formData,
      date: today(true),
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeSep = (no_sep) => {
    setFormData({
      ...formData,
      no_sep,
    })
  }

  const updateRegistrasiSEP = (noSep) => {
    const payload = {
      date: toUTCFormat(formData.date),
      kelaskunjungan_id: formData.kelaskunjungan_id,
      patients_id: formData.patients_id,
      nohp: formData.nohp,
      nik: formData.nik,
      company_id: formData.company_id,
      insurance_id: formData.insurance_id,
      insurance_no: formData.insurance_no,
      norujukan: formData.norujukan,
      nokontrol: formData.nokontrol,
      nosep: noSep,
    }

    return instance2.post(LIST_URL_REGISTRASI.kunjungan_igd.update, payload, {
      headers: {
        idregistration: registrationId,
      },
    })
  }

  const { ButtonCetakManualSEP, ModalPrintManualSep } = useModalCetakManualSEP({
    formData,
  })

  return (
    <>
      {showModalCancel && (
        <ModalCancel
          registrationId={registrationId}
          setRegistrationId={setRegistrationId}
          setNewData={setNewData}
          url="/registration/registration/cancel_registration_igd"
          setShowModal={() => setShowModalCancel(false)}
        />
      )}

      {showModalDuplikasiSEP.state && (
        <ModalDeleteConfirm
          title="Duplikasi SEP"
          labelConfirm="Ya, saya mengerti"
          msg={showModalDuplikasiSEP.message}
          confirmHandle={() =>
            setShowModalDuplikasiSEP({
              state: false,
              message: "",
            })
          }
        />
      )}

      <ModalConfirmBukaKunjungan />
      <ModalPrintManualSep />
      {showModalTutup && (
        <ModalTutupKunjungan
          registrationId={registrationId}
          setRegistrationId={setRegistrationId}
          setNewData={setNewData}
          setShowModal={() => setShowModalTutup(false)}
        />
      )}

      {showModalForce && (
        <ModalForceAsuransi
          rows={rowsForce}
          handleSubmit={handleSubmit}
          setShowModal={() => setShowModalForce(false)}
        />
      )}

      <Paper className={classes.paper}>
        {showModalTriage && (
          <ModalTriage
            rowsTriage={rowsTriage}
            setRowsTriage={setRowsTriage}
            formData={formData}
            setFormData={setFormData}
            setShowModal={() => setShowModalTriage(false)}
          />
        )}
        <form onSubmit={(e) => handleSubmit(e)}>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={6}>
                <p style={{ color: "#D8D8D8", fontSize: "10px" }}>
                  ID KUNJUNGAN
                </p>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <p style={{ fontSize: 30, marginTop: "0.5rem" }}>
                    {" "}
                    {registrationId}{" "}
                  </p>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Grid container direction="row" justifyContent="flex-end">
                  <MasterButton
                    type={"button"}
                    color="green"
                    name="Kunjungan Baru"
                    size="xs"
                    withIcon={true}
                    icon={
                      <Person
                        style={{
                          width: "15px",
                        }}
                      />
                    }
                    onClick={handleClickButtonKunjunganBaru}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className="mt-1">
            <Grid container spacing={1}>
              <Grid item sm={3}>
                <InputReactDatepicker
                  selected={formData.date}
                  label="TANGGAL"
                  isClearable={false}
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      date: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      date: e,
                    })
                  }
                />
              </Grid>

              <Grid item sm={3}>
                <InputTextMaster
                  name="id_triage"
                  label="TRIAGE"
                  id="id_triage"
                  disabled={true}
                  placeholder={formData.label_triage}
                  withButton={true}
                >
                  {isNull(registrationId) && (
                    <button
                      type={"button"}
                      onClick={() => setShowModalTriage(!showModalTriage)}
                      style={{
                        borderRight: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderLeft: "0",
                        background: "#fff",
                        padding: "0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "0 6px 6px 0",
                      }}
                    >
                      <SearchIcon width={"12"} height={"12"} fill={"#333"} />
                    </button>
                  )}
                </InputTextMaster>
              </Grid>

              <Grid item sm={3}>
                <InputOptionMaster
                  name="doctor_id"
                  label="DOKTER"
                  id="doctor_id"
                  withSearch={true}
                  needParse={false}
                  data={master.dokter.list_select}
                  labelValue={formData.doctor_name}
                  value={formData.doctor_id}
                  error={true}
                  message={messageError.required}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      doctor_id: e.value,
                      doctor_name: e.label,
                    })
                  }}
                />
              </Grid>

              <Grid item xs={3}>
                <InputOptionMaster
                  name="sebab_sakit"
                  label="SEBAB SAKIT"
                  id="sebab_sakit"
                  withSearch={false}
                  needParse={false}
                  data={sebabSakitSelect}
                  value={formData.sebab_sakit}
                  onChange={handleChange("sebab_sakit")}
                />
              </Grid>
            </Grid>
          </div>

          <FormDataPasien
            handleChange={handleChange}
            formData={formData}
            setFormData={setFormData}
            registrationId={registrationId}
          />

          <FormAsuransi
            handleChange={handleChangeAsuransi}
            handleChanges={handleChange}
            formData={formData}
            setFormData={setFormData}
            registrationId={registrationId}
          />

          <Grid item xs={3}>
            <InputOptionMaster
              name="cara_masuk"
              label="CARA MASUK"
              id="cara_masuk"
              withSearch={true}
              data={optionCaraMasuk}
              value={formData.cara_masuk}
              labelValue={formData.cara_masuk_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    cara_masuk: null,
                    cara_masuk_name: "Pilih Cara Masuk",
                  })
                } else {
                  setFormData({
                    ...formData,
                    cara_masuk: e.value,
                    cara_masuk_name: e.label,
                  })
                }
              }}
              error={true}
              message={messageError.required}
            />
          </Grid>

          {showModalSEP && (
            <ModalSEP
              setShowModal={() => setShowModalSEP(false)}
              pekerjaan={formData.pekerjaan}
              noRujukan={formData.norujukan}
              registrationID={registrationId}
              noSep={formData.no_sep}
              detailSep={detailSEP}
              noBPJS={formData.insurance_no}
              tglLahir={defaultDateDisplay(formData.date_ob, false)}
              jenisKelamin={formData.gender_print === 1 ? "L" : "P"}
              patientID={formData.norm}
              tglKunjungan={defaultDateInputDisplay(formData.date, false)}
              handleChangeSep={handleChangeSep}
              updateRegistrasi={updateRegistrasiSEP}
              dokterNama={formData.doctor_name}
            />
          )}

          {!isNull(registrationId) && (
            <FormSEP
              hanleClickButtonSep={handleClickButtonSEP}
              noSep={formData.no_sep}
              handleChange={handleChange}
            />
          )}

          <Grid item sm={4}>
            <div className="mt-1">
              <InputCheckboxMaster
                checked={formData.validasi_bpjs}
                name="validasi_bpjs"
                id="validasi_bpjs"
                label="Validasi BPJS"
                onChange={() =>
                  setFormData({
                    ...formData,
                    validasi_bpjs: !formData.validasi_bpjs,
                  })
                }
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <InputTextArea
              name="remark"
              label="CATATAN"
              id="remark"
              rows={4}
              value={formData.remark}
              onChange={handleChange("remark")}
            />
          </Grid>

          <div className="mt-2">
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                {registrationId !== "" && (
                  <>
                    {parseInt(setting.buka_tutup_button_igd.tutup) === 1 && (
                      <MasterButton
                        type="button"
                        color={"lightgreen"}
                        name={"Tutup Kunjungan"}
                        onClick={() => setShowModalTutup(!showModalTutup)}
                        size="md"
                      />
                    )}

                    <MasterButton
                      type="button"
                      color={"warning"}
                      name={"Batal Kunjungan"}
                      onClick={() => setShowModalCancel(!showModalCancel)}
                      size="md"
                    />

                    {parseInt(setting.buka_tutup_button_igd.buka) === 1 &&
                      formData.status && <ButtonBukaKunjungan />}
                  </>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                {registrationId !== "" && (
                  <>
                    <Grid item>
                      <ButtonCetakManualSEP />
                    </Grid>
                    <ButtonActionIgd
                      formData={formData}
                      registrationId={registrationId}
                    />
                  </>
                )}

                <MasterButton
                  type="button"
                  color="danger"
                  name="Reset"
                  onClick={() => {
                    setRegistrationId("")
                    setFormData({
                      ...RESET_STATE_KUNJUNGAN_IGD,
                      date: today(true),
                    })
                  }}
                  size="md"
                />

                <MasterButton
                  type="submit"
                  disabled={disabled.state}
                  color={disabled.color}
                  name={isNull(registrationId) ? disabled.label : "Update"}
                  size="md"
                />
              </div>
            </Grid>
          </div>
        </form>
      </Paper>
    </>
  )
}
